import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
  onSnapshot,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../config/firebase";

function EventsTab() {
  const [events, setEvents] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  // --- NOUVEAUX ÉTATS POUR LES NOTIFICATIONS ---
  const [toast, setToast] = useState(null); // { msg: "Texte", type: "success" | "error" }
  const [deleteTargetId, setDeleteTargetId] = useState(null); // ID de l'élément à supprimer

  const [formData, setFormData] = useState({
    title_fr: "",
    title_en: "",
    type: "ARTICLE",
    date: "",
    isoDate: "",
    desc_fr: "",
    desc_en: "",
    link: "",
  });
  const [imageFile, setImageFile] = useState(null);
  const [currentImageUrl, setCurrentImageUrl] = useState("");

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "events"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      data.sort((a, b) => new Date(b.isoDate) - new Date(a.isoDate));
      setEvents(data);
    });
    return () => unsub();
  }, []);

  // Fonction utilitaire pour afficher la notification pendant 3 secondes
  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  const handleImageUpload = async (file) => {
    if (!file) return null;
    const storageRef = ref(storage, `events/${Date.now()}_${file.name}`);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading(true);

    try {
      let finalImageUrl = currentImageUrl;

      if (imageFile) {
        finalImageUrl = await handleImageUpload(imageFile);
      }

      if (!finalImageUrl) {
        showToast("Veuillez ajouter une image !", "error");
        setIsUploading(false);
        return;
      }

      const eventPayload = { ...formData, image: finalImageUrl };

      if (editingId) {
        await updateDoc(doc(db, "events", editingId), eventPayload);
        showToast("Événement mis à jour avec succès !");
      } else {
        await addDoc(collection(db, "events"), eventPayload);
        showToast("Événement publié avec succès !");
      }

      closeModal();
    } catch (err) {
      showToast("Erreur : " + err.message, "error");
    }
    setIsUploading(false);
  };

  // --- NOUVELLE LOGIQUE DE SUPPRESSION ---
  const confirmDelete = async () => {
    if (!deleteTargetId) return;
    try {
      await deleteDoc(doc(db, "events", deleteTargetId));
      showToast("Événement supprimé !");
    } catch (err) {
      showToast("Erreur lors de la suppression.", "error");
    }
    setDeleteTargetId(null); // On ferme la modale
  };

  const openEditModal = (event) => {
    setEditingId(event.id);
    setFormData({
      title_fr: event.title_fr || event.title || "",
      title_en: event.title_en || "",
      type: event.type || "ARTICLE",
      date: event.date || "",
      isoDate: event.isoDate || "",
      desc_fr: event.desc_fr || event.desc || "",
      desc_en: event.desc_en || "",
      link: event.link || "",
    });
    setCurrentImageUrl(event.image || "");
    setImageFile(null);
  };

  const closeModal = () => {
    setEditingId(null);
    setFormData({
      title_fr: "",
      title_en: "",
      type: "ARTICLE",
      date: "",
      isoDate: "",
      desc_fr: "",
      desc_en: "",
      link: "",
    });
    setCurrentImageUrl("");
    setImageFile(null);
  };

  return (
    <div className="fade-in">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h3>Liste des événements ({events.length})</h3>
        <button
          onClick={() => openEditModal({})}
          style={{ ...btnStyle, background: "#00f0ff" }}
        >
          + NOUVEL ÉVÉNEMENT
        </button>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
          gap: "20px",
        }}
      >
        {events.map((event) => (
          <div
            key={event.id}
            style={{
              background: "rgba(255,255,255,0.03)",
              borderRadius: "12px",
              border: "1px solid rgba(255,255,255,0.05)",
              overflow: "hidden",
            }}
          >
            <img
              src={event.image}
              alt=""
              style={{ width: "100%", height: "180px", objectFit: "cover" }}
            />
            <div style={{ padding: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <strong style={{ fontSize: "1.1rem", color: "#fff" }}>
                  {event.title_fr || event.title}
                </strong>
                <span
                  style={{
                    fontSize: "0.7rem",
                    padding: "3px 8px",
                    background: "rgba(0,240,255,0.1)",
                    color: "#00f0ff",
                    borderRadius: "4px",
                  }}
                >
                  {event.type}
                </span>
              </div>
              <p
                style={{ fontSize: "0.8rem", color: "#888", marginTop: "5px" }}
              >
                {event.date}
              </p>

              <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                <button
                  onClick={() => openEditModal(event)}
                  style={{
                    flex: 1,
                    padding: "8px",
                    background: "rgba(255,255,255,0.1)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Modifier
                </button>
                {/* On ouvre la modale de suppression au lieu du confirm natif */}
                <button
                  onClick={() => setDeleteTargetId(event.id)}
                  style={{
                    padding: "8px 15px",
                    background: "transparent",
                    border: "1px solid #ff3366",
                    color: "#ff3366",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* MODALE DE CRÉATION/ÉDITION */}
      {editingId !== null && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h2>
                {editingId ? "Modifier l'événement" : "Créer un événement"}
              </h2>
              <button
                onClick={closeModal}
                style={{
                  background: "transparent",
                  color: "white",
                  border: "none",
                  fontSize: "1.5rem",
                  cursor: "pointer",
                }}
              >
                ×
              </button>
            </div>

            <form
              onSubmit={handleSubmit}
              style={{ display: "flex", flexDirection: "column", gap: "15px" }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "10px",
                }}
              >
                <input
                  type="text"
                  placeholder="Titre (FR)"
                  required
                  value={formData.title_fr}
                  onChange={(e) =>
                    setFormData({ ...formData, title_fr: e.target.value })
                  }
                  style={inputStyle}
                />
                <input
                  type="text"
                  placeholder="Title (EN)"
                  required
                  value={formData.title_en}
                  onChange={(e) =>
                    setFormData({ ...formData, title_en: e.target.value })
                  }
                  style={inputStyle}
                />
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                  style={inputStyle}
                >
                  <option value="ARTICLE">ARTICLE</option>
                  <option value="SALON">SALON</option>
                  <option value="WEBINAIRE">WEBINAIRE</option>
                  <option value="FESTIVAL">FESTIVAL</option>
                  <option value="INTERVIEW">INTERVIEW</option>
                </select>
                <input
                  type="date"
                  required
                  value={formData.isoDate}
                  onChange={(e) =>
                    setFormData({ ...formData, isoDate: e.target.value })
                  }
                  style={inputStyle}
                />
                <input
                  type="text"
                  placeholder="Date publique (ex: 15 Fév)"
                  required
                  value={formData.date}
                  onChange={(e) =>
                    setFormData({ ...formData, date: e.target.value })
                  }
                  style={inputStyle}
                />
              </div>
              <textarea
                placeholder="Description (FR)"
                required
                rows="2"
                value={formData.desc_fr}
                onChange={(e) =>
                  setFormData({ ...formData, desc_fr: e.target.value })
                }
                style={inputStyle}
              />
              <textarea
                placeholder="Description (EN)"
                required
                rows="2"
                value={formData.desc_en}
                onChange={(e) =>
                  setFormData({ ...formData, desc_en: e.target.value })
                }
                style={inputStyle}
              />
              <input
                type="url"
                placeholder="Lien de redirection (optionnel)"
                value={formData.link}
                onChange={(e) =>
                  setFormData({ ...formData, link: e.target.value })
                }
                style={inputStyle}
              />

              <div
                style={{
                  background: "rgba(255,255,255,0.05)",
                  padding: "15px",
                  borderRadius: "8px",
                  border: "1px dashed #555",
                }}
              >
                <p style={{ margin: "0 0 10px 0", fontSize: "0.9rem" }}>
                  Image de l'événement
                </p>
                {currentImageUrl && !imageFile && (
                  <img
                    src={currentImageUrl}
                    alt="Actuelle"
                    style={{
                      height: "60px",
                      borderRadius: "4px",
                      marginBottom: "10px",
                      display: "block",
                    }}
                  />
                )}
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setImageFile(e.target.files[0])}
                  style={{ color: "white" }}
                />
              </div>

              <button
                type="submit"
                disabled={isUploading}
                style={{
                  ...btnStyle,
                  background: "#00f0ff",
                  opacity: isUploading ? 0.5 : 1,
                }}
              >
                {isUploading
                  ? "Enregistrement en cours..."
                  : editingId
                    ? "METTRE À JOUR"
                    : "PUBLIER"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* --- AFFICHAGE DU TOAST --- */}
      {toast && <div className={`cms-toast ${toast.type}`}>{toast.msg}</div>}

      {/* --- MODALE DE CONFIRMATION DE SUPPRESSION --- */}
      {deleteTargetId && (
        <div className="confirm-overlay">
          <div className="confirm-box">
            <h3>Action irréversible</h3>
            <p>
              Es-tu sûr de vouloir supprimer cet événement ? Il disparaîtra
              immédiatement du site public.
            </p>
            <div className="confirm-actions">
              <button
                className="confirm-btn-cancel"
                onClick={() => setDeleteTargetId(null)}
              >
                Annuler
              </button>
              <button className="confirm-btn-delete" onClick={confirmDelete}>
                Oui, supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// --- STYLES EN LIGNE RESTANTS ---
const inputStyle = {
  padding: "12px",
  background: "rgba(0,0,0,0.5)",
  border: "1px solid #333",
  color: "white",
  borderRadius: "8px",
  width: "100%",
  boxSizing: "border-box",
};
const btnStyle = {
  padding: "12px 20px",
  color: "#000",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
};
const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.8)",
  backdropFilter: "blur(5px)",
  zIndex: 1000,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const modalContentStyle = {
  background: "#111118",
  padding: "30px",
  borderRadius: "15px",
  border: "1px solid #333",
  width: "90%",
  maxWidth: "600px",
  maxHeight: "90vh",
  overflowY: "auto",
};

export default EventsTab;
